module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAgElEQVR4AWOgC/gPAz9////3Hx9AaPj95+/1C1tO7iq9eXnHz58/CWt48vDG3sV6xxYx7Vmo8/zpPZCcxQpMhNDw7OndfYt0jixg2r9E98mjG4Rt+PHjx41L207uKL52ftOfP38J2QAG/4Ce/gWkifA0VsPw2oAAA24D6RoGJQAAWdpkU6pXIIkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/UY.png
// module id = 1293
// module chunks = 0